export default "__VITE_ASSET__JFVkHfWO__"